import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import TranslatedCopy from '../../intl/translated-copy';
import { sendAnalytics } from '../../analytics/tracker';
import manageTracking from '../../analytics/creators/manage';

class FormInputErrorMessage extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { dispatch, name } = this.props;
    dispatch(sendAnalytics({
      eventCreator: manageTracking.errorFormTracking(name),
    }));
  }

  render() {
    const {
      name,
      error,
      errorMessageData,
      errorWidth,
    } = this.props;

    let copyID = error;
    let data = '';

    if (typeof error === 'object') {
      copyID = error.copyID;
      data = error.data;
    } else if (errorMessageData) {
      data = errorMessageData;
    }

    const classes = cx({
      'FormInput-error': true,
      'FormInput-error--inline': errorWidth,
    });

    const styles = errorWidth ? {
      'width': `${errorWidth}px`,
    } : {};

    return (
      <div
        className={ classes }
        role='tooltip'
        style={ styles }>
        <TranslatedCopy
          copyID={ copyID }
          data={ data }
          id={ `${name}-error-text` } />
      </div>
    );
  }
}
export const FormInputErrorMessageDisconnected = FormInputErrorMessage;

FormInputErrorMessage = connect()(FormInputErrorMessage);
export default FormInputErrorMessage;
